<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
import cbLogo from 'assets/images/cb_logo.png';

const emptyFormData = () => ({
  phone: '',
  job_option_1: '',
  experience_description: '',
  'Telefone para recado com DDD': '',
  Facebook: '',
  Instagram: '',
  LinkedIn: '',
  Sexo: '',
  RG: '',
  'Data de nascimento': '',
  Naturalidade: '',
  'Endereço — rua/avenida': '',
  Número: '',
  Bairro: '',
  'Cidade/UF': '',
  CEP: '',
  'Local de nascimento — cidade/UF ou país': '',
  'Tempo estimado de deslocamento até a empresa': '',
  'Valor total diário das conduções — ida e volta': '',
  'Você possui alguma alergia ou condição que deva ser considerada no ambiente de trabalho?':
    '',
  'Nome da Mãe': '',
  'Cidade de Nascimento da Mãe': '',
  'Nome do Pai': '',
  'Cidade de Nascimento do Pai': '',
  'Mora com quem': '',
  'Grau de escolaridade': '',
  'Estuda atualmente?': '',
  'Se estuda, o que está cursando?': '',
  'Se estuda, onde?': '',
  'Você tem experiência na vaga desejada?': '',
  Idiomas: [],
  'Conhecimentos em informática': '',
  'Outros cursos e certificações': '',
  'Número do calçado': '',
  'Tamanho da blusa': '',
  'Pretensão salarial': '',
  'Último cargo': '',
  'Último salário': '',
  'Disponibilidade de horário': [],
  'Tem disponibilidade para trabalhar em escala 6x1?': '',
  'Aceita trabalhar aos sábados, domingos e feriados?': '',
  'Tem disponibilidade para viagens?': '',
  'Tem disponibilidade para mudança?': '',
  'Descreva seu deslocamento de casa até o Coco Bambu Uberlândia.': '',
  'Trabalha atualmente?': '',
  'Empresa atual': '',
  'Função atual': '',
  'Salário atual': '',
  'Empresa 1': '',
  'Cargo 1': '',
  'Período/duração 1': '',
  'Motivo da saída 1': '',
  'Referência profissional 1 — nome e contato': '',
  'Empresa 2': '',
  'Cargo 2': '',
  'Período/duração 2': '',
  'Motivo da saída 2': '',
  'Referência profissional 2 — nome e contato': '',
  'Como ficou sabendo da vaga?': '',
  'Por que você quer trabalhar aqui?': '',
  'O que você sabe sobre o Coco Bambu?': '',
  'Qual é seu plano para os próximos 2 anos?': '',
  'Qual foi sua maior conquista até hoje?': '',
  'Conte um erro que cometeu e o que aprendeu com ele.': '',
  'O que motiva você no trabalho?': '',
  'Quanto tempo você pretende ficar conosco?': '',
  'Fale 3 pontos positivos sobre você.': '',
  'Fale 3 pontos que deseja desenvolver.': '',
});

export default {
  name: 'JobApplicationForm',
  directives: { mask },
  data() {
    return {
      cbLogo,
      currentStep: 0,
      stepError: '',
      isSubmitting: false,
      successMessage: '',
      errorMessage: '',
      originalDocumentTitle: null,
      scheduledDate: null,
      steps: [
        'Oportunidade',
        'Dados Pessoais',
        'Situação Familiar',
        'Grau de escolaridade',
        'Outras Informações',
        'Possibilidade de Contratação',
        'Informações Profissionais',
        'Sobre a vaga',
        'Mais sobre você',
      ],
      form: {
        name: '',
        email: '',
        cpf: '',
        form_data: emptyFormData(),
      },
    };
  },
  computed: {
    isLastStep() {
      return this.currentStep === this.steps.length - 1;
    },
    progressPercent() {
      return ((this.currentStep + 1) / this.steps.length) * 100;
    },
    formattedDate() {
      if (!this.scheduledDate) return '';
      const [year, month, day] = this.scheduledDate.split('-');
      const dateObj = new Date(year, month - 1, day);
      const days = [
        'Domingo',
        'Segunda-feira',
        'Terça-feira',
        'Quarta-feira',
        'Quinta-feira',
        'Sexta-feira',
        'Sábado',
      ];
      return `${days[dateObj.getDay()]}, ${day}/${month}/${year}`;
    },
  },
  mounted() {
    this.originalDocumentTitle = document.title;
    document.title = 'Recrutamento e Seleção — Coco Bambu Uberlândia';
  },
  beforeUnmount() {
    if (this.originalDocumentTitle != null) {
      document.title = this.originalDocumentTitle;
    }
  },
  methods: {
    hasIdioma(value) {
      return (
        Array.isArray(this.form.form_data.Idiomas) &&
        this.form.form_data.Idiomas.includes(value)
      );
    },
    toggleIdioma(value, event) {
      const list = Array.isArray(this.form.form_data.Idiomas)
        ? [...this.form.form_data.Idiomas]
        : [];
      if (event.target.checked) {
        if (!list.includes(value)) list.push(value);
      } else {
        const idx = list.indexOf(value);
        if (idx > -1) list.splice(idx, 1);
      }
      this.form.form_data.Idiomas = list;
    },
    hasHorario(value) {
      return (
        Array.isArray(this.form.form_data['Disponibilidade de horário']) &&
        this.form.form_data['Disponibilidade de horário'].includes(value)
      );
    },
    toggleHorario(value, event) {
      const list = Array.isArray(
        this.form.form_data['Disponibilidade de horário']
      )
        ? [...this.form.form_data['Disponibilidade de horário']]
        : [];
      if (event.target.checked) {
        if (!list.includes(value)) list.push(value);
      } else {
        const idx = list.indexOf(value);
        if (idx > -1) list.splice(idx, 1);
      }
      this.form.form_data['Disponibilidade de horário'] = list;
    },
    validateCurrentStep() {
      this.stepError = '';
      const root = this.$refs[`step${this.currentStep}`];
      const el = Array.isArray(root) ? root[0] : root;
      if (!el) return true;

      const fields = Array.from(el.querySelectorAll('input, select, textarea'));
      const invalidField = fields.find(field => !field.checkValidity());
      if (invalidField) {
        invalidField.reportValidity();
        return false;
      }

      if (
        this.currentStep === 5 &&
        !this.form.form_data['Disponibilidade de horário'].length
      ) {
        this.stepError = 'Selecione ao menos uma disponibilidade de horário.';
        return false;
      }

      return true;
    },
    nextStep() {
      if (!this.validateCurrentStep()) return;
      if (this.currentStep < this.steps.length - 1) {
        this.currentStep += 1;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    prevStep() {
      this.stepError = '';
      if (this.currentStep > 0) {
        this.currentStep -= 1;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    onFormSubmit() {
      if (!this.isLastStep) {
        this.nextStep();
        return;
      }
      if (!this.validateCurrentStep()) return;
      this.submitApplication();
    },
    async submitApplication() {
      this.isSubmitting = true;
      this.successMessage = '';
      this.errorMessage = '';
      this.stepError = '';
      this.scheduledDate = null;

      const accountId = this.$route.params.account_id;

      try {
        const response = await axios.post(
          `/api/v1/public/forms/${accountId}/jobs`,
          {
            job_application: this.form,
          }
        );

        this.scheduledDate = response.data.interview_date;
        this.successMessage = this.scheduledDate
          ? 'Candidatura enviada com sucesso!'
          : 'Candidatura enviada com sucesso! Entraremos em contato.';
        this.form = {
          name: '',
          email: '',
          cpf: '',
          form_data: emptyFormData(),
        };
      } catch (error) {
        this.errorMessage =
          error.response?.data?.error ||
          'Ocorreu um erro ao enviar sua candidatura. Tente novamente.';
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<template>
  <div
    class="job-application-container helena-theme helena-page-bg min-h-screen py-12 px-4"
  >
    <div
      class="max-w-3xl mx-auto bg-white rounded-lg shadow-sm overflow-hidden border border-slate-200"
    >
      <header
        class="flex flex-col md:flex-row items-center gap-4 p-6 md:p-8 border-b border-slate-200 bg-white"
      >
        <div class="shrink-0">
          <img
            :src="cbLogo"
            alt="Coco Bambu"
            class="w-16 h-16 object-contain"
          />
        </div>
        <div class="text-center md:text-left">
          <div
            class="text-primary-500 text-xs font-bold uppercase tracking-widest"
          >
            Recrutamento e Seleção
          </div>
          <h1
            class="text-slate-900 text-2xl md:text-3xl font-semibold mt-1 mb-1"
          >
            Coco Bambu Uberlândia
          </h1>
          <p class="text-slate-500 text-sm m-0">
            Preencha seus dados abaixo para se candidatar às vagas disponíveis.
          </p>
        </div>
      </header>

      <form novalidate class="space-y-6 p-8" @submit.prevent="onFormSubmit">
        <div v-if="!successMessage" class="step-progress">
          <div class="flex justify-between items-center mb-2">
            <p class="text-sm font-semibold text-slate-700 m-0">
              {{ steps[currentStep] }}
            </p>
            <p class="text-xs text-slate-500 m-0">
              Etapa {{ currentStep + 1 }} de {{ steps.length }}
            </p>
          </div>
          <div class="step-track">
            <div class="step-fill" :style="{ width: progressPercent + '%' }" />
          </div>
        </div>

        <fieldset
          v-show="!successMessage && currentStep === 0"
          ref="step0"
          class="border border-slate-200 rounded p-4"
        >
          <legend class="text-sm font-semibold text-slate-700 px-2">
            Oportunidade
          </legend>
          <div class="grid grid-cols-1 gap-4 mt-2">
            <div>
              <label class="field-label">Vaga desejada (1ª opção) *</label>
              <select
                v-model="form.form_data.job_option_1"
                required
                class="field-input"
              >
                <option value="">Selecione...</option>
                <option value="Atendimento">Atendimento (Garçom, Cumin)</option>
                <option value="Cozinha">Cozinha (Cozinheiro, Auxiliar)</option>
                <option value="Administrativo">Administrativo</option>
              </select>
            </div>
          </div>
        </fieldset>

        <fieldset
          v-show="!successMessage && currentStep === 1"
          ref="step1"
          class="border border-slate-200 rounded p-4"
        >
          <legend class="text-sm font-semibold text-slate-700 px-2">
            Dados Pessoais
          </legend>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <div class="md:col-span-2">
              <label class="field-label">Nome Completo *</label>
              <input
                v-model="form.name"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">E-mail *</label>
              <input
                v-model="form.email"
                type="email"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Telefone / WhatsApp *</label>
              <input
                v-model="form.form_data.phone"
                v-mask="'(##) #####-####'"
                type="tel"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Telefone para recado com DDD</label>
              <input
                v-model="form.form_data['Telefone para recado com DDD']"
                v-mask="'(##) #####-####'"
                type="tel"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Facebook</label>
              <input
                v-model="form.form_data['Facebook']"
                type="text"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Instagram</label>
              <input
                v-model="form.form_data['Instagram']"
                type="text"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">LinkedIn</label>
              <input
                v-model="form.form_data['LinkedIn']"
                type="text"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Sexo *</label>
              <select
                v-model="form.form_data['Sexo']"
                required
                class="field-input"
              >
                <option value="">Selecione...</option>
                <option value="Masculino">Masculino</option>
                <option value="Feminino">Feminino</option>
              </select>
            </div>
            <div>
              <label class="field-label">CPF *</label>
              <input
                v-model="form.cpf"
                v-mask="'###.###.###-##'"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">RG *</label>
              <input
                v-model="form.form_data['RG']"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Data de nascimento *</label>
              <input
                v-model="form.form_data['Data de nascimento']"
                type="date"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Naturalidade *</label>
              <select
                v-model="form.form_data['Naturalidade']"
                required
                class="field-input"
              >
                <option value="">Selecione...</option>
                <option value="Brasileira">Brasileira</option>
                <option value="Outra">Outra</option>
              </select>
            </div>
            <div class="md:col-span-2">
              <label class="field-label">Endereço — rua/avenida *</label>
              <input
                v-model="form.form_data['Endereço — rua/avenida']"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Número *</label>
              <input
                v-model="form.form_data['Número']"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Bairro *</label>
              <input
                v-model="form.form_data['Bairro']"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Cidade/UF *</label>
              <input
                v-model="form.form_data['Cidade/UF']"
                type="text"
                required
                class="field-input"
                placeholder="Uberlândia/MG"
              />
            </div>
            <div>
              <label class="field-label">CEP *</label>
              <input
                v-model="form.form_data['CEP']"
                v-mask="'#####-###'"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div class="md:col-span-2">
              <label class="field-label"
                >Local de nascimento — cidade/UF ou país *</label
              >
              <input
                v-model="
                  form.form_data['Local de nascimento — cidade/UF ou país']
                "
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label"
                >Tempo estimado de deslocamento até a empresa *</label
              >
              <input
                v-model="
                  form.form_data['Tempo estimado de deslocamento até a empresa']
                "
                type="text"
                required
                class="field-input"
                placeholder="Ex: 40 minutos"
              />
            </div>
            <div>
              <label class="field-label"
                >Valor total diário das conduções — ida e volta *</label
              >
              <input
                v-model="
                  form.form_data[
                    'Valor total diário das conduções — ida e volta'
                  ]
                "
                type="text"
                required
                class="field-input"
                placeholder="Ex: 12,00"
              />
            </div>
            <div class="md:col-span-2">
              <label class="field-label"
                >Você possui alguma alergia ou condição que deva ser considerada
                no ambiente de trabalho? *</label
              >
              <input
                v-model="
                  form.form_data[
                    'Você possui alguma alergia ou condição que deva ser considerada no ambiente de trabalho?'
                  ]
                "
                type="text"
                required
                class="field-input"
              />
            </div>
          </div>
        </fieldset>

        <fieldset
          v-show="!successMessage && currentStep === 2"
          ref="step2"
          class="border border-slate-200 rounded p-4"
        >
          <legend class="text-sm font-semibold text-slate-700 px-2">
            Situação Familiar
          </legend>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <div>
              <label class="field-label">Nome da Mãe *</label>
              <input
                v-model="form.form_data['Nome da Mãe']"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Cidade de Nascimento da Mãe *</label>
              <input
                v-model="form.form_data['Cidade de Nascimento da Mãe']"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Nome do Pai *</label>
              <input
                v-model="form.form_data['Nome do Pai']"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Cidade de Nascimento do Pai *</label>
              <input
                v-model="form.form_data['Cidade de Nascimento do Pai']"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div class="md:col-span-2">
              <label class="field-label">Mora com quem *</label>
              <input
                v-model="form.form_data['Mora com quem']"
                type="text"
                required
                class="field-input"
              />
            </div>
          </div>
        </fieldset>

        <fieldset
          v-show="!successMessage && currentStep === 3"
          ref="step3"
          class="border border-slate-200 rounded p-4"
        >
          <legend class="text-sm font-semibold text-slate-700 px-2">
            Grau de escolaridade
          </legend>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <div class="md:col-span-2">
              <label class="field-label">Grau de escolaridade *</label>
              <select
                v-model="form.form_data['Grau de escolaridade']"
                required
                class="field-input"
              >
                <option value="">Selecione...</option>
                <option value="Analfabeto">Analfabeto</option>
                <option value="Ensino Fundamental Incompleto (Até 4ª Série)">
                  Ensino Fundamental Incompleto (Até 4ª Série)
                </option>
                <option value="Ensino Fundamental Incompleto">
                  Ensino Fundamental Incompleto
                </option>
                <option value="Ensino Fundamental Completo">
                  Ensino Fundamental Completo
                </option>
                <option value="Ensino Médio Incompleto">
                  Ensino Médio Incompleto
                </option>
                <option value="Ensino Médio Completo">
                  Ensino Médio Completo
                </option>
                <option value="Educação Superior Incompleto">
                  Educação Superior Incompleto
                </option>
                <option value="Educação Superior Completo">
                  Educação Superior Completo
                </option>
              </select>
            </div>
            <div>
              <label class="field-label">Estuda atualmente? *</label>
              <select
                v-model="form.form_data['Estuda atualmente?']"
                required
                class="field-input"
              >
                <option value="">Selecione...</option>
                <option value="Sim">Sim</option>
                <option value="Não">Não</option>
              </select>
            </div>
            <div v-if="form.form_data['Estuda atualmente?'] === 'Sim'">
              <label class="field-label">Se estuda, o que está cursando?</label>
              <input
                v-model="form.form_data['Se estuda, o que está cursando?']"
                type="text"
                class="field-input"
              />
            </div>
            <div v-if="form.form_data['Estuda atualmente?'] === 'Sim'">
              <label class="field-label">Se estuda, onde?</label>
              <input
                v-model="form.form_data['Se estuda, onde?']"
                type="text"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label"
                >Você tem experiência na vaga desejada? *</label
              >
              <select
                v-model="
                  form.form_data['Você tem experiência na vaga desejada?']
                "
                required
                class="field-input"
              >
                <option value="">Selecione...</option>
                <option value="Sim">Sim</option>
                <option value="Não">Não</option>
              </select>
            </div>
            <div
              v-if="
                form.form_data['Você tem experiência na vaga desejada?'] ===
                'Sim'
              "
              class="md:col-span-2"
            >
              <label class="field-label"
                >Se sim, qual? Descreva resumidamente</label
              >
              <textarea
                v-model="form.form_data.experience_description"
                rows="3"
                class="field-input"
              />
            </div>
            <div class="md:col-span-2">
              <label class="field-label">Idiomas</label>
              <div class="flex flex-wrap gap-4 mt-1">
                <label
                  class="inline-flex items-center gap-2 text-sm text-slate-700"
                >
                  <input
                    type="checkbox"
                    value="Inglês"
                    :checked="hasIdioma('Inglês')"
                    @change="toggleIdioma('Inglês', $event)"
                  />
                  Inglês
                </label>
                <label
                  class="inline-flex items-center gap-2 text-sm text-slate-700"
                >
                  <input
                    type="checkbox"
                    value="Espanhol"
                    :checked="hasIdioma('Espanhol')"
                    @change="toggleIdioma('Espanhol', $event)"
                  />
                  Espanhol
                </label>
              </div>
            </div>
            <div>
              <label class="field-label">Conhecimentos em informática</label>
              <input
                v-model="form.form_data['Conhecimentos em informática']"
                type="text"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Outros cursos e certificações</label>
              <input
                v-model="form.form_data['Outros cursos e certificações']"
                type="text"
                class="field-input"
              />
            </div>
          </div>
        </fieldset>

        <fieldset
          v-show="!successMessage && currentStep === 4"
          ref="step4"
          class="border border-slate-200 rounded p-4"
        >
          <legend class="text-sm font-semibold text-slate-700 px-2">
            Outras Informações
          </legend>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <div>
              <label class="field-label">Número do calçado *</label>
              <input
                v-model="form.form_data['Número do calçado']"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Tamanho da blusa *</label>
              <select
                v-model="form.form_data['Tamanho da blusa']"
                required
                class="field-input"
              >
                <option value="">Selecione...</option>
                <option value="PP">PP</option>
                <option value="P">P</option>
                <option value="M">M</option>
                <option value="G">G</option>
                <option value="GG">GG</option>
              </select>
            </div>
          </div>
        </fieldset>

        <fieldset
          v-show="!successMessage && currentStep === 5"
          ref="step5"
          class="border border-slate-200 rounded p-4"
        >
          <legend class="text-sm font-semibold text-slate-700 px-2">
            Sobre a Possibilidade de Contratação
          </legend>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <div>
              <label class="field-label">Pretensão salarial *</label>
              <input
                v-model="form.form_data['Pretensão salarial']"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Último cargo</label>
              <input
                v-model="form.form_data['Último cargo']"
                type="text"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Último salário</label>
              <input
                v-model="form.form_data['Último salário']"
                type="text"
                class="field-input"
              />
            </div>
            <div class="md:col-span-2">
              <label class="field-label">Disponibilidade de horário *</label>
              <div class="space-y-2 mt-1 text-sm text-slate-700">
                <label class="flex items-center gap-2">
                  <input
                    type="checkbox"
                    value="Abertura 08:00h - 16:20h"
                    :checked="hasHorario('Abertura 08:00h - 16:20h')"
                    @change="toggleHorario('Abertura 08:00h - 16:20h', $event)"
                  />
                  Abertura 08:00h - 16:20h
                </label>
                <label class="flex items-center gap-2">
                  <input
                    type="checkbox"
                    value="Intercalado 11:00h - 15:00h/19:00h - 22:20h"
                    :checked="
                      hasHorario('Intercalado 11:00h - 15:00h/19:00h - 22:20h')
                    "
                    @change="
                      toggleHorario(
                        'Intercalado 11:00h - 15:00h/19:00h - 22:20h',
                        $event
                      )
                    "
                  />
                  Intercalado 11:00h - 15:00h/19:00h - 22:20h
                </label>
                <label class="flex items-center gap-2">
                  <input
                    type="checkbox"
                    value="Fechamento 16:00h - 00:20h"
                    :checked="hasHorario('Fechamento 16:00h - 00:20h')"
                    @change="
                      toggleHorario('Fechamento 16:00h - 00:20h', $event)
                    "
                  />
                  Fechamento 16:00h - 00:20h
                </label>
              </div>
            </div>
            <div>
              <label class="field-label"
                >Tem disponibilidade para trabalhar em escala 6x1? *</label
              >
              <select
                v-model="
                  form.form_data[
                    'Tem disponibilidade para trabalhar em escala 6x1?'
                  ]
                "
                required
                class="field-input"
              >
                <option value="">Selecione...</option>
                <option value="Sim">Sim</option>
                <option value="Não">Não</option>
              </select>
            </div>
            <div>
              <label class="field-label"
                >Aceita trabalhar aos sábados, domingos e feriados? *</label
              >
              <select
                v-model="
                  form.form_data[
                    'Aceita trabalhar aos sábados, domingos e feriados?'
                  ]
                "
                required
                class="field-input"
              >
                <option value="">Selecione...</option>
                <option value="Sim">Sim</option>
                <option value="Não">Não</option>
              </select>
            </div>
            <div>
              <label class="field-label"
                >Tem disponibilidade para viagens? *</label
              >
              <select
                v-model="form.form_data['Tem disponibilidade para viagens?']"
                required
                class="field-input"
              >
                <option value="">Selecione...</option>
                <option value="Sim">Sim</option>
                <option value="Não">Não</option>
              </select>
            </div>
            <div>
              <label class="field-label"
                >Tem disponibilidade para mudança? *</label
              >
              <select
                v-model="form.form_data['Tem disponibilidade para mudança?']"
                required
                class="field-input"
              >
                <option value="">Selecione...</option>
                <option value="Sim">Sim</option>
                <option value="Não">Não</option>
              </select>
            </div>
            <div class="md:col-span-2">
              <label class="field-label"
                >Descreva seu deslocamento de casa até o Coco Bambu Uberlândia.
                *</label
              >
              <textarea
                v-model="
                  form.form_data[
                    'Descreva seu deslocamento de casa até o Coco Bambu Uberlândia.'
                  ]
                "
                rows="3"
                required
                class="field-input"
              />
            </div>
          </div>
        </fieldset>

        <fieldset
          v-show="!successMessage && currentStep === 6"
          ref="step6"
          class="border border-slate-200 rounded p-4"
        >
          <legend class="text-sm font-semibold text-slate-700 px-2">
            Informações Profissionais
          </legend>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <div>
              <label class="field-label">Trabalha atualmente? *</label>
              <select
                v-model="form.form_data['Trabalha atualmente?']"
                required
                class="field-input"
              >
                <option value="">Selecione...</option>
                <option value="Sim">Sim</option>
                <option value="Não">Não</option>
              </select>
            </div>
            <div v-if="form.form_data['Trabalha atualmente?'] === 'Sim'">
              <label class="field-label">Empresa atual</label>
              <input
                v-model="form.form_data['Empresa atual']"
                type="text"
                class="field-input"
              />
            </div>
            <div v-if="form.form_data['Trabalha atualmente?'] === 'Sim'">
              <label class="field-label">Função atual</label>
              <input
                v-model="form.form_data['Função atual']"
                type="text"
                class="field-input"
              />
            </div>
            <div v-if="form.form_data['Trabalha atualmente?'] === 'Sim'">
              <label class="field-label">Salário atual</label>
              <input
                v-model="form.form_data['Salário atual']"
                type="text"
                class="field-input"
              />
            </div>

            <div
              class="md:col-span-2 text-sm font-semibold text-slate-700 mt-2"
            >
              Última empresa 1
            </div>
            <div>
              <label class="field-label">Empresa 1</label>
              <input
                v-model="form.form_data['Empresa 1']"
                type="text"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Cargo 1</label>
              <input
                v-model="form.form_data['Cargo 1']"
                type="text"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Período/duração 1</label>
              <input
                v-model="form.form_data['Período/duração 1']"
                type="text"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Motivo da saída 1</label>
              <input
                v-model="form.form_data['Motivo da saída 1']"
                type="text"
                class="field-input"
              />
            </div>
            <div class="md:col-span-2">
              <label class="field-label"
                >Referência profissional 1 — nome e contato</label
              >
              <input
                v-model="
                  form.form_data['Referência profissional 1 — nome e contato']
                "
                type="text"
                class="field-input"
              />
            </div>

            <div
              class="md:col-span-2 text-sm font-semibold text-slate-700 mt-2"
            >
              Última empresa 2
            </div>
            <div>
              <label class="field-label">Empresa 2</label>
              <input
                v-model="form.form_data['Empresa 2']"
                type="text"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Cargo 2</label>
              <input
                v-model="form.form_data['Cargo 2']"
                type="text"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Período/duração 2</label>
              <input
                v-model="form.form_data['Período/duração 2']"
                type="text"
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label">Motivo da saída 2</label>
              <input
                v-model="form.form_data['Motivo da saída 2']"
                type="text"
                class="field-input"
              />
            </div>
            <div class="md:col-span-2">
              <label class="field-label"
                >Referência profissional 2 — nome e contato</label
              >
              <input
                v-model="
                  form.form_data['Referência profissional 2 — nome e contato']
                "
                type="text"
                class="field-input"
              />
            </div>
          </div>
        </fieldset>

        <fieldset
          v-show="!successMessage && currentStep === 7"
          ref="step7"
          class="border border-slate-200 rounded p-4"
        >
          <legend class="text-sm font-semibold text-slate-700 px-2">
            Sobre a vaga
          </legend>
          <div class="grid grid-cols-1 gap-4 mt-2">
            <div>
              <label class="field-label">Como ficou sabendo da vaga? *</label>
              <input
                v-model="form.form_data['Como ficou sabendo da vaga?']"
                type="text"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label"
                >Por que você quer trabalhar aqui? *</label
              >
              <textarea
                v-model="form.form_data['Por que você quer trabalhar aqui?']"
                rows="3"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label"
                >O que você sabe sobre o Coco Bambu? *</label
              >
              <textarea
                v-model="form.form_data['O que você sabe sobre o Coco Bambu?']"
                rows="3"
                required
                class="field-input"
              />
            </div>
          </div>
        </fieldset>

        <fieldset
          v-show="!successMessage && currentStep === 8"
          ref="step8"
          class="border border-slate-200 rounded p-4"
        >
          <legend class="text-sm font-semibold text-slate-700 px-2">
            Queremos saber um pouco mais sobre você
          </legend>
          <div class="grid grid-cols-1 gap-4 mt-2">
            <div>
              <label class="field-label"
                >Qual é seu plano para os próximos 2 anos? *</label
              >
              <textarea
                v-model="
                  form.form_data['Qual é seu plano para os próximos 2 anos?']
                "
                rows="3"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label"
                >Qual foi sua maior conquista até hoje? *</label
              >
              <textarea
                v-model="
                  form.form_data['Qual foi sua maior conquista até hoje?']
                "
                rows="3"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label"
                >Conte um erro que cometeu e o que aprendeu com ele. *</label
              >
              <textarea
                v-model="
                  form.form_data[
                    'Conte um erro que cometeu e o que aprendeu com ele.'
                  ]
                "
                rows="3"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label"
                >O que motiva você no trabalho? *</label
              >
              <textarea
                v-model="form.form_data['O que motiva você no trabalho?']"
                rows="3"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label"
                >Quanto tempo você pretende ficar conosco? *</label
              >
              <textarea
                v-model="
                  form.form_data['Quanto tempo você pretende ficar conosco?']
                "
                rows="2"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label"
                >Fale 3 pontos positivos sobre você. *</label
              >
              <textarea
                v-model="form.form_data['Fale 3 pontos positivos sobre você.']"
                rows="3"
                required
                class="field-input"
              />
            </div>
            <div>
              <label class="field-label"
                >Fale 3 pontos negativos sobre você? *</label
              >
              <textarea
                v-model="
                  form.form_data['Fale 3 pontos que deseja desenvolver.']
                "
                rows="3"
                required
                class="field-input"
              />
            </div>
          </div>
        </fieldset>

        <div class="pt-4 flex flex-col sm:flex-row gap-3 sm:justify-between">
          <button
            v-if="currentStep > 0 && !successMessage"
            type="button"
            class="btn-secondary"
            @click="prevStep"
          >
            Voltar
          </button>
          <div v-else class="hidden sm:block" />

          <button
            v-if="!isLastStep && !successMessage"
            type="button"
            class="btn-primary"
            @click="nextStep"
          >
            Continuar
          </button>
          <button
            v-else-if="!successMessage"
            type="submit"
            :disabled="isSubmitting"
            class="btn-primary disabled:opacity-50"
          >
            {{ isSubmitting ? 'Enviando...' : 'Enviar Candidatura' }}
          </button>
        </div>

        <div
          v-if="stepError"
          class="p-3 bg-amber-50 text-amber-800 rounded-md border border-amber-200 text-sm"
        >
          {{ stepError }}
        </div>
        <div
          v-if="successMessage"
          class="mt-2 p-4 bg-green-50 text-green-800 rounded-md border border-green-200"
        >
          <p class="font-bold mb-2">{{ successMessage }}</p>
          <p v-if="scheduledDate" class="text-base">
            Sua entrevista está marcada para
            <strong class="text-green-900">{{ formattedDate }}</strong
            >. Anote esta data e compareça no local.
          </p>
          <p v-else>
            Em breve entraremos em contato com a data da sua entrevista.
          </p>
        </div>
        <div
          v-if="errorMessage"
          class="mt-2 p-4 bg-red-50 text-red-700 rounded-md border border-red-200"
        >
          {{ errorMessage }}
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.helena-page-bg {
  background: radial-gradient(
      circle at 0% 0%,
      rgba(236, 72, 153, 0.12) 0%,
      transparent 42%
    ),
    radial-gradient(
      circle at 100% 0%,
      rgba(6, 182, 212, 0.12) 0%,
      transparent 40%
    ),
    radial-gradient(
      circle at 100% 100%,
      rgba(79, 70, 229, 0.14) 0%,
      transparent 45%
    ),
    linear-gradient(160deg, #eef2ff 0%, #f8fafc 48%, #e0e7ff 100%);
}
.field-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #334155;
  margin-bottom: 0.25rem;
}
.field-input {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.field-input:focus {
  outline: none;
  border-color: rgb(99 102 241);
  box-shadow: 0 0 0 1px rgb(99 102 241);
}
.step-track {
  height: 6px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}
.step-fill {
  height: 100%;
  background: rgb(99 102 241);
  transition: width 0.2s ease;
}
.btn-primary,
.btn-secondary {
  appearance: none;
  border: 0;
  border-radius: 0.5rem;
  min-height: 48px;
  padding: 0 1.25rem;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: background 0.15s ease;
}
.btn-primary {
  background: rgb(99 102 241);
  color: white;
}
.btn-primary:hover {
  background: rgb(79 70 229);
}
.btn-secondary {
  background: white;
  color: #334155;
  border: 1px solid #cbd5e1;
}
.btn-secondary:hover {
  background: #f8fafc;
}
</style>
